import React from 'react'
import Dropzone from 'react-dropzone-uploader';
import { Col, Card, CardHeader, CardBody, CardFooter } from 'reactstrap'; // or whatever UI library you're using
import { H5 , Btn} from '../../../AbstractElements';
function InvoiceStepTwo({handleBack, handleNext}) {
  const handleChangeStatus = ({ meta, file }, status) => {};
  const getUploadParams = ({ meta }) => {
    return {
      url: 'https://httpbin.org/post',
    };
  };

  return (
    <Col sm="12">
      <Card className="card-absolute">
        <CardHeader className="bg-primary">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <H5>Invoice File</H5>
          </div>
        </CardHeader>
        <CardBody>
          <Dropzone
            className='dropzone dz-clickable'
            getUploadParams={getUploadParams}
            onChangeStatus={handleChangeStatus}
            maxFiles={1}
            multiple={false}
            canCancel={false}
            inputContent='Drop A File'
            styles={{
              dropzone: { width: '100%', height: 150 },
              dropzoneActive: { borderColor: 'green' },
            }}
          />
          <CardFooter className="text-end">
            <Btn
              attrBtn={{
                color: "secondary",
                className: "m-r-15",
                onClick: handleBack,
              }}
        
            >
              Back to Step One
            </Btn>
            <Btn
              attrBtn={{
                color: "primary",
                className: "m-r-15",
                type: "submit",
              }}
              
            >
              Next Step
            </Btn>
          </CardFooter>
        </CardBody>
      </Card>
    </Col>
  )
}

export default InvoiceStepTwo